var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('div',{staticClass:"d-flex justify-space-between"},[_c('h2',[_vm._v(_vm._s(_vm.title))])]),_c('v-container',[_c('line-chart',{attrs:{"chart-data":_vm.datacollection,"options":_vm.options}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }